import type { LocationQuery, LocationQueryRaw } from 'vue-router'
import { INBOX_CHANNELS, type InboxChannel } from '@/utils/inboxChannels'

export type InboxThreadScope = 'all' | 'unread' | 'unassigned'
export type InboxChannelScope = 'all' | InboxChannel
export interface InboxLocation {
  thread: string | null
  conversationId: string | null
  teachingId: string | null
  supportId: string | null
  scope: InboxThreadScope
  channel: InboxChannelScope
  search: string
  statusId?: string | null
}

export function inboxQueryValue(query: LocationQuery, key: string): string | null {
  const value = Array.isArray(query[key]) ? query[key][0] : query[key]
  return typeof value === 'string' && value.trim() ? value.trim() : null
}

export function readInboxLocation(query: LocationQuery): InboxLocation {
  const thread = inboxQueryValue(query, 'thread')
  const channel = inboxQueryValue(query, 'channel')
  const scope = inboxQueryValue(query, 'scope')
  const supportId = inboxQueryValue(query, 'supportId')
  const teachingId = supportId ? null : inboxQueryValue(query, 'teachingId')
  return {
    thread: thread && /^(student|conversation|support):[^\s:]+$/.test(thread) ? thread : null,
    conversationId: teachingId || supportId ? null : inboxQueryValue(query, 'conversationId'),
    teachingId,
    supportId,
    scope: scope === 'unread' || scope === 'unassigned' ? scope : 'all',
    channel: INBOX_CHANNELS.includes(channel as InboxChannel) ? channel as InboxChannel : 'all',
    search: inboxQueryValue(query, 'q') ?? '',
    statusId: inboxQueryValue(query, 'statusId'),
  }
}

export function inboxLocationQuery(current: LocationQuery, location: InboxLocation): LocationQueryRaw {
  const query: LocationQueryRaw = { ...current }
  for (const key of ['thread', 'conversationId', 'teachingId', 'supportId', 'scope', 'channel', 'q', 'statusId']) delete query[key]
  if (location.thread) query.thread = location.thread
  if (location.conversationId) query.conversationId = location.conversationId
  if (location.teachingId) query.teachingId = location.teachingId
  if (location.supportId) query.supportId = location.supportId
  if (location.scope !== 'all') query.scope = location.scope
  if (location.channel !== 'all') query.channel = location.channel
  if (location.statusId) query.statusId = location.statusId
  if (location.search.trim()) query.q = location.search.trim()
  return query
}
